import React, {Component} from 'react';
import Header from "../Header";
import AppNavbar from "../Sidebar";
import Favicon from "react-favicon";
import MetaTags from "react-meta-tags";
import axios from "axios";
import 'react-data-table-component-extensions/dist/index.css';

export default class PortfolioMonthlySummary extends Component {


    constructor (props) {
        super(props)
        this.state = {
            loggedInUser:null,
            monthID: 'January',
            yearID: '2024',
            userId: '',
            gatewayID: '1',
            disabled : false,
            userViewInfo: []
        };
        this.handleToYear = this.handleToYear.bind(this);
        this.handleToUserId = this.handleToUserId.bind(this);
        this.handleToMonth = this.handleToMonth.bind(this);
        this.handleToGatewayID = this.handleToGatewayID.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {

        axios.get(`getLoggedUserName?JSESSIONID=${sessionStorage.getItem('COOKIE')}`)
            .then(response => {

                this.setState({ loggedInUser: response.data })
                console.log("=== LOG_1 === Inside componentDidMount %s with data ","ACH Terminal",this.state.loggedInUser);
                //Get Terminal Ids


            }).finally(()=> {
            axios.get('getUserViewList?id='+this.state.loggedInUser)
                .then(response => {
                    this.setState({ userViewInfo: response.data.response,loading: false })
                }).finally(()=> {
            })
                .catch(error => {
                    console.log("Exception Thrown::{ get Terminal details by ID}",error);
                });
        })
            .catch(error => {
                console.log("GOT ERROR HERE for Get LoggedIn User",error);
            });


    }

    handleToYear(event) {
        console.log("Changed Value for Date-----",event.target.value)
        this.setState({
            yearID: event.target.value
        });
    }

    handleToUserId(event) {
        console.log("Changed Value for user-----",event.target.value)
        this.setState({
            userId: event.target.value
        });
    }

    handleToMonth(event) {
        console.log("Changed Value -----",event.target.value)
        this.setState({
            monthID: event.target.value
        });
    }
    handleToGatewayID(event) {
        console.log("Changed Value -----",event.target.value)
        this.setState({
            gatewayID: event.target.value
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        console.log(this.state.monthID,"FromDate ---- ----Todate ------terminalId",this.state.yearID,this.state.userId);
        if(this.state.monthID === '' || this.state.yearID === ''){
            alert(" Please provide valid  Date !!")
            return false;
        }
        if (this.state.disabled) {
            return;
        }
       // this.setState({disabled: true});
        axios({
            url: 'downloadProfitSummaryReport?pDestCode='+ this.state.gatewayID+"&month="+this.state.monthID+"&year="+this.state.yearID+"&userID="+this.state.userId, //your url
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'PortfolioMonthlySummary.xls'); //or any other extension
            document.body.appendChild(link);
            link.click();
            //this.setState({disabled: false});
        });
    }

    render() {

        const alignBox = {
            display: "flex",
            justifyContent: "space-around"
        };

        const terminalList = this.state.userViewInfo.map((i) => {
            return <option value={i.userId}>{i.userId}</option>;
        });
        terminalList.unshift(<option value={this.state.loggedInUser}>{this.state.loggedInUser}</option>)

        return (
            <body data-sidebar="colored">
            <div id="layout-wrapper">
                <Header/>
                <AppNavbar data={this.state}/>
            </div>
            <div className="main-content">
                <Favicon url='https://passporttechnology.com/images/base/favicon-16x16.png' />
                <MetaTags>
                    <title>DataStream Version 2.0</title>
                    <meta name="description" content="DataStream Version 2.0" />
                    <meta property="og:title" content="DataStream Version 2.0" />
                </MetaTags>
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box d-flex align-items-center justify-content-between">
                                    <h4 className="mb-0">Report Management</h4>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-9">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="tab-content p-3 text-muted">
                                            <div className="form-group">
                                                <form onSubmit={ this.handleSubmit }>
                                                    <div className="form-group" style={alignBox}>
                                                        <div>

                                                                <label className="control-label">User Id: </label>
                                                            <select name="userId" id="userId" className="custom-select" onChange={this.handleToUserId} >
                                                                {terminalList}
                                                            </select>
                                                        </div>
                                                        <div>
                                                            <label  className="control-label">Month: </label>
                                                            <select name="monthID" id="monthID" className="custom-select" onChange={this.handleToMonth} >
                                                                <option selected="selected" value="January">January</option>
                                                                <option value="February">February</option>
                                                                <option value="March">March</option>
                                                                <option value="April">April</option>
                                                                <option value="May">May</option>
                                                                <option value="June">June</option>
                                                                <option value="July">July</option>
                                                                <option value="August">August</option>
                                                                <option value="September">September</option>
                                                                <option value="October">October</option>
                                                                <option value="November">November</option>
                                                                <option value="December">December</option>
                                                            </select>
                                                        </div>
                                                        <div>
                                                            <label  className="control-label">Year: </label>
                                                            <select name="yearID" id="yearID" className="custom-select" onChange={this.handleToYear} >
                                                                <option value="2028">2028</option>
                                                                <option value="2027">2027</option>
                                                                <option value="2026">2026</option>
                                                                <option value="2025">2025</option>
                                                                <option selected="selected" value="2024">2024</option>
                                                                <option value="2023">2023</option>
                                                                <option value="2022">2022</option>
                                                                <option value="2021">2021</option>
                                                                <option value="2020">2020</option>
                                                                <option value="2019">2019</option>
                                                                <option value="2018">2018</option>
                                                                <option value="2017">2017</option>
                                                                <option value="2016">2016</option>
                                                                <option value="2015">2015</option>
                                                                <option value="2014">2014</option>
                                                                <option value="2013">2013</option>
                                                                <option value="2012">2012</option>
                                                            </select>
                                                        </div>
                                                        <div>
                                                            <label  className="control-label">Destination Code</label>
                                                            <select name="gatewayID" id="gatewayID" className="custom-select" onChange={this.handleToGatewayID} >
                                                                <option selected="selected"  value="1">All</option>
                                                                <option value="0">RBS WorldPay</option>
                                                                <option value="4">USBank</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <button className="btn btn-primary" onClick={this.handleClick} disabled={this.state.disabled} >Generate Report</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </body>
        );
    }
}